interface HeroOvalDividerProps {
    color?: 'brand-50' | 'brand-100';
}

export const HeroOvalDivider = ({ color = 'brand-50' }: HeroOvalDividerProps) => {
    return (
        <section className="relative overflow-x-hidden pt-5">
            <div className={`w-full h-[100px] md:h-[160px] lg:h-[160px] bg-${color} rounded-t-[100%]`}></div>
        </section>
    );
};
